/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_ANSWER } from "./actionTypes"
import { apiError, editAnswerSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updateAnswer } from "../../../helpers/backend_helper"

function* edit(request) {
  try {
    const response = yield call(updateAnswer, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(editAnswerSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* answerEditSaga() {
  yield takeEvery(EDIT_ANSWER, edit)
}

export default answerEditSaga
